export enum CouponScope {
    ORDER = "ORDER",
    EVENT = "EVENT"
}
